// src/components/BlankSpace.js
import React from 'react';
import '../styles/BlankSpace.css';

function BlankSpace() {
  return (
    <section className="blankspace-section">
      <div className="blankspace-container">
      </div>
    </section>
  );
}

export default BlankSpace;
